const BASE_URL = process.env.API_URL;

export const IDENTITY_ENDPOINTS = {
  IDENTITY_BASE: `${BASE_URL}/api/v1/identity`
};

export const PAYMENT_COLLECTION_ENDPOINTS = {
  GET_PLAID_LINK_TOKEN: `${BASE_URL}/api/v1/paymentcollection/GetLinkPlaidToken`
};

export const GAP_WAIVER_ENDPOINTS = {
  GET_ELIGIBILITY: `${BASE_URL}/api/v1/gapwaiver/eligible`,
  RESET: `${BASE_URL}/api/v1/gapwaiver/reset`,
  DECLINE: `${BASE_URL}/api/v1/gapwaiver/decline`
};
